// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1zegE","addWidgetButton":"Header_addWidgetButton__1LNr_","dashboardTabs":"Header_dashboardTabs__3DRrx","active":"Header_active__2dD1x"};